import SalaryAdvancePrice from "components/salaryAdvancePrice";
import FasterPaymentAddon from "components/fasterPaymentAddon";
import * as React from 'react';
export default {
  SalaryAdvancePrice,
  FasterPaymentAddon,
  React
};